// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  defaultauth: 'myfile', //'fackbackend',
  appVersion: '1.14.1',
  tableConfigVersion: '2',

//powershell -File ".\\docker-compose\build_access_dev_docker_image.ps1"
//powershell -File ".\\docker-compose\build_access_prod_docker_image.ps1"

  /** Luxxai API */
  aiApiUrl: 'https://luxxaiapi-dev.luxxai.com/v1',
  staticImageApiUrl: 'https://luxxaiapi-dev.luxxai.com/Images/',
  apiUrl: 'https://luxxaiapi-dev.luxxai.com/v1',
  
  
  // aiApiUrl: 'https://localhost:6001/v1',
  // staticImageApiUrl: 'https://localhost:6001/Images/',
  // apiUrl: 'https://localhost:6001/v1',

  //aiApiUrl: 'https://luxxaiapi-local.luxxai.com/v1',
  //staticImageApiUrl: 'https://luxxaiapi-local.luxxai.com/Images/',
  /** END */


  msalAzureConfig: {
    clientId: "3d1e3ef3-e61b-47c1-92fb-4581e3ac1808",
    authority: "https://login.microsoftonline.com/common",
    redirectUri: `${window.location.origin}/auth/oauth-redirect-signin` // change redirect url based on where u want to redirect after the authentication
  },
  oAuthUrls: {
    signIn: {
      facebookOauth: `https://spearsoftware.b2clogin.com/spearsoftware.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_Facebook_OAuth&client_id=d828322a-f829-4b44-9140-499aeca5278d&nonce=defaultNonce&redirect_uri=${window.location.origin}%2Fauth%2Foauth-redirect-signin&scope=openid&response_type=id_token&prompt=login`,
      appleOauth: `https://spearsoftware.b2clogin.com/spearsoftware.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_OAuth-Apple&client_id=d828322a-f829-4b44-9140-499aeca5278d&nonce=defaultNonce&redirect_uri=${window.location.origin}%2Fauth%2Foauth-redirect-signin&scope=openid&response_type=id_token&prompt=login`,
      googleOauth: `https://spearsoftware.b2clogin.com/spearsoftware.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_MyFile_Development&client_id=d828322a-f829-4b44-9140-499aeca5278d&nonce=defaultNonce&redirect_uri=${window.location.origin}%2Fauth%2Foauth-redirect-signin&scope=openid&response_type=id_token&prompt=login`,
    },
    signUp: {
      facebookOauth: `https://spearsoftware.b2clogin.com/spearsoftware.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_Facebook_OAuth&client_id=d828322a-f829-4b44-9140-499aeca5278d&nonce=defaultNonce&redirect_uri=${window.location.origin}%2Fauth%2Foauth-redirect-signup&scope=openid&response_type=id_token&prompt=login`,
      appleOauth: `https://spearsoftware.b2clogin.com/spearsoftware.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_OAuth-Apple&client_id=d828322a-f829-4b44-9140-499aeca5278d&nonce=defaultNonce&redirect_uri=${window.location.origin}%2Fauth%2Foauth-redirect-signup&scope=openid&response_type=id_token&prompt=login`,
      googleOauth: `https://spearsoftware.b2clogin.com/spearsoftware.onmicrosoft.com/oauth2/v2.0/authorize?p=B2C_1_MyFile_Development&client_id=d828322a-f829-4b44-9140-499aeca5278d&nonce=defaultNonce&redirect_uri=${window.location.origin}%2Fauth%2Foauth-redirect-signup&scope=openid&response_type=id_token&prompt=login`,
    },
  },

  stripeCheckoutPublicKey: `pk_test_51RExQBRWgOXfL6PLOF4oW8vbbhwUx8eDBqXBDijFbZWcQOCWKyG39iYYwkZYcYt89MwzoQMiGxirvHXXh9ombcnZ00zqUtXeWa`,
  recaptchaKey: `6Le7afIsAAAAAHNT1U-rAZA9kZsvccP-tK4OgFVJ`,

  USERDATA_KEY: 'authf649fc9a5f55',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: ''
  },

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
